// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".semantic-ui .image-details .review-actions .ui.basic.buttons {\n  min-width: 212px;\n}\n", ""]);
// Exports
module.exports = exports;
